export default "__VITE_ASSET__b0ccfd04__"